<template>
  <CoolLightBox
    :items="items"
    :index="index"
    @close="index = null">
  </CoolLightBox>
</template>

<script>
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

export default{
  props : {
    items : Array,
    index : Number
  },

  components : {
    CoolLightBox
  }
}
</script>
